<template>
  <div>
    <transition name="Blur">
      <div class="Blur" v-if="isBlur" />
    </transition>
  </div>
</template>

<script>
import * as BABYLON from 'babylonjs'

export default {
  name: 'Blur',
  data: () => ({
    isBlur: false
  }),
  watch: {
    '$route': {
      immediate: true,
      handler() {

        if(this.is2DWorld || this.$route.params.page)
          this.blur()

        if(this.slugIsIn(['pan', 'secret']))
          this.unblur()


        if(this.slugIsIn(['pan', 'secret']))
          this.unblur()


        if(this.slugIsIn(['monde', 'monde:1', 'monde:2'])) {
          this.$parent.blur = this.isBlur = true
          this.$store.commit('app/SET_RENDER', true)
        }
        else if(this.is3DWorld)
          this.unblur()

        if(this.slugIsIn(['instructions'])){
          this.unblur()
          setTimeout(this.blur, 100)
        }
      }
    }
  },
  methods: {
    blur() {
      this.$parent.blur = this.isBlur = true
      this.$store.commit('app/SET_RENDER', false)
    },
    unblur() {
      this.$parent.blur = this.isBlur = false
      this.$store.commit('app/SET_RENDER', true)
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Blur
  position fixed
  width 100vw
  height 100vh
  top 0px
  left 0px
  transition opacity 1s
  background rgba(black, .35)
  &-enter
  &-leave-active
    opacity 0
</style>



// WEBPACK FOOTER //
// src/components/world/elements/Blur.vue